const registerForm = {
  title: 'Cree su cuenta',
  fullName: {
    label: 'Nombre completo',
    placeholder: 'Ej.: Sofía Rodríguez',
  },
  email: {
    placeholder: 'Ingrese su correo electrónico',
  },
  institution: {
    label: '¿Cómo se llama su institución educativa?',
    placeholder: 'Ej: Universidad de La Salle',
  },
  terms: {
    prefix: 'Acepto los',
    conjunction: ' y el <br class="block md:hidden" />',
  },
  registerButton: 'Crear cuenta',
}

const pymeDefaultHero = {
  title: 'Gestione su negocio desde <br /><span class="text-sm-primary-600">un solo lugar</span>.',
  subtitle:
    'Facture, venda y controle sus finanzas con herramientas diseñadas para pymes como la suya.',
}

const pymeDefaultFeatures = {
  1: 'Facturación electrónica homologada con Hacienda, sin rechazos.',
  2: 'Punto de venta ágil con control de inventario en tiempo real.',
  3: 'La IA trabaja con usted para simplificar cada proceso.',
}

const posHero = {
  title: 'Su punto de venta, más ágil e <span class="text-sm-primary-600">inteligente</span>.',
  subtitle:
    'Registre sus ventas desde el mostrador, controle su stock en tiempo real y cumpla con Hacienda sin complicaciones.',
}

const posFeatures = {
  1: 'Facture desde su punto de venta físico, homologado con Hacienda 4.4.',
  2: 'Cree su catálogo de productos y servicios una vez y reutilícelos en cada factura.',
  3: 'Controle su inventario y ventas en tiempo real desde su punto de venta.',
}

const recommendation = {
  title: 'Cuéntenos cómo opera su negocio',
  titleWithIcp: 'Tres preguntas rápidas',
  subtitle: '',
  subtitleWithIcp:
    'Sus respuestas nos permiten recomendarle la solución que mejor se adapta a su negocio.',
  continueButton: 'Continuar',
  backButton: 'Volver',
  steps: {
    createAccount: 'Crear cuenta',
    aboutBusiness: 'Sobre su negocio',
    idealSolution: 'Su solución ideal',
  },
  questions: {
    1: {
      label: '¿Cómo realiza la mayoría de sus ventas?',
      options: {
        a: 'Desde mi negocio o punto de venta físico',
        b: 'A distancia o de forma remota',
      },
    },
    2: {
      label: '¿A quién le vende principalmente?',
      options: {
        a: 'Al consumidor final o público general',
        b: 'A empresas u organizaciones',
      },
    },
    3: {
      label: '¿Cómo suele cobrar sus ventas?',
      options: {
        a: 'En el momento con tarjeta, efectivo o SINPE',
        b: 'Emito factura y cobro a crédito',
      },
    },
  },
  analyzing: {
    title: 'Analizando su negocio...',
    subtitle: 'En un momento le mostramos la solución ideal.',
    status: {
      1: 'Canal de venta evaluado',
      2: 'Tipo de cliente evaluado',
      3: 'Modelo de cobro evaluado',
      4: 'Asignando solución...',
    },
  },
  solution: {
    title: 'Encontramos la solución ideal para usted',
    subtitles: {
      SF: 'Con <strong>{productName}</strong> puede facturar y controlar sus ventas, todo certificado por Hacienda.',
      AC: 'Con <strong>{productName}</strong> puede facturar, controlar sus gastos y tener sus finanzas al día con Hacienda desde un solo lugar.',
      POS: 'Con <strong>{productName}</strong> puede facturar desde el mostrador, controlar su inventario y cobrar al instante.',
    },
    answersLabel: 'Estas fueron sus respuestas:',
    startButton: 'Comenzar con {productName}',
    editButton: 'Editar mis respuestas',
    products: {
      SF: 'Alegra Facturación',
      POS: 'Alegra POS',
      AC: 'Alegra ERP',
    },
  },
}

const jtbdRecommendation = {
  sublabel: 'Seleccione todas las que desee.',
  title: '¿Qué necesita resolver en su negocio actualmente?',
  continueButton: 'Continuar',
  backButton: 'Volver',
  recommendedTag: 'Recomendado',
  analyzing: {
    title: 'Analizando su negocio...',
    subtitle: 'En un momento su solución ideal estará lista.',
    status: {
      1: 'Necesidades identificadas',
      2: 'Perfil de su negocio evaluado',
      3: 'Mejor solución calculada',
      4: 'Asignando solución...',
    },
  },
  jobs: {
    facturar: {
      title: 'Emitir facturas',
      description: 'Quiero crear y enviar documentos electrónicos a mis clientes.',
    },
    pos: {
      title: 'Vender en mi punto de venta',
      description:
        'Quiero vender desde un local físico y mantener el control total de mi efectivo.',
    },
    contabilidad: {
      title: 'Llevar mi contabilidad',
      description: 'Quiero tener control centralizado de mis compras, igastos e inventario.',
    },
    nomina: {
      title: 'Gestionar la nómina de mi equipo',
      description:
        'Quiero calcular los sueldos y las deducciones de mi equipo, en regla y a tiempo.',
    },
  },
  solution: {
    title: 'Esta es su solución recomendada',
    idealTag: 'Ideal para usted',
    startButton: 'Comenzar con {productName}',
    editButton: 'Editar respuestas',
    alternativeTitle: 'Has seleccionado otra solución',
    chooseButton: 'Elegir {productName}',
    backToRecommendationButton: 'Volver a mi recomendación',
    alternativesLabel: 'O también puedes probar',
    alternativeLabels: {
      SF: 'Facturación',
      POS: 'POS',
      AC: 'ERP',
      NOMINA: 'Nómina',
    },
    products: {
      SF: 'Alegra Facturación',
      POS: 'Alegra POS',
      AC: 'Alegra ERP',
      NOMINA: 'Alegra Nómina',
    },
    benefits: {
      SF: [
        'Su primera factura electrónica lista en <br /> menos de una hora.',
        'Sus comprobantes electrónicos cumplen con Hacienda, sin rechazos desde el primer día.',
      ],
      POS: [
        'Cobre desde el mostrador en <br /> segundos, con o sin internet.',
        'Su caja cuadra automáticamente al <br /> cierre del día.',
      ],
      AC: [
        'Estados financieros al día son esperar <br /> el cierre contable.',
        'Facturación, inventario y contabilidad <br /> integrados en un solo lugar.',
      ],
      NOMINA: [
        'Tu primera nómina calculada en minutos, con todas las deducciones al día.',
        'Tus reportes para la DGII quedan listos para enviar, con total tranquilidad.',
      ],
    },
  },
}

const withMobileHeader = (hero: { title: string; subtitle: string }) => ({
  ...hero,
  mobileHeader: hero.title,
})

const registerBlock = ({
  hero,
  features,
}: {
  hero: { title: string; subtitle: string }
  features: Record<number, string>
}) => ({
  register: {
    hero: withMobileHeader(hero),
    features,
    form: registerForm,
  },
})

export default {
  shared: {
    pills: {
      primary: '15 días gratis',
      secondary: 'Sin tarjeta',
    },
    studentCard: {
      question: '¿Es estudiante?',
      message: ' Acceda a una experiencia diseñada para su aprendizaje ',
      link: 'aquí',
    },
    chooseIcp: {
      title: '¿Cómo describe mejor su trabajo?',
      continueButton: 'Continuar',
      studentLink: {
        question: '¿Estás estudiando?',
        prefix: 'Ingresa a',
        label: 'Alegra para estudiantes',
      },
      options: {
        SMALL_BUSINESS: {
          title: 'Tengo un negocio y quiero facturar',
          description:
            'Cree sus facturas en minutos, envíelas a sus clientes y controle sus ventas.',
        },
        ACCOUNTANT: {
          title: 'Soy contador/a y gestiono varios clientes',
          description:
            'Lleve la contabilidad de sus clientes al día desde un solo lugar y obtenga visibilidad de su negocio.',
        },
        MID_BUSINESS: {
          title: 'Mi empresa ya creció y necesito controlar todo',
          description:
            'Unifique su contabilidad, facturación e inventario en una sola plataforma.',
        },
      },
      experiment: {
        options: {
          SMALL_BUSINESS: {
            title: 'Tengo una pequeña empresa',
            description: 'Me encargo personalmente de administrar mi negocio.',
          },
          ACCOUNTANT: {
            title: 'Soy contador/a',
            description: 'Gestiono la contabilidad de varios clientes y cada uno tiene su propio negocio.',
          },
          MID_BUSINESS: {
            title: 'Tengo una empresa en crecimiento',
            description: 'Mi empresa tiene equipos definidos y procesos establecidos.',
          },
        },
      },
    },
    recommendation,
    jtbdRecommendation,
  },
  NO_ICP: {
    default: {
      ...registerBlock({
        hero: pymeDefaultHero,
        features: pymeDefaultFeatures,
      }),
    },
    POS: {
      ...registerBlock({
        hero: posHero,
        features: posFeatures,
      }),
    },
    NOMINA: {
      ...registerBlock({
        hero: {
          title: 'Gestiona la nómina de tu <br />equipo desde <span class="text-sm-primary-600">un solo lugar</span>.',
          subtitle: 'Calcula sueldos, deducciones legales y pagos en minutos.',
        },
        features: {
          1: 'Sueldos, deducciones y horas extra se calculan solos, con la DGII siempre al día.',
          2: 'Tus reportes para la DGII se generan automáticamente, listos para enviar.',
          3: 'Tu nómina se integra con tu contabilidad, así todo tu negocio queda conectado.',
        },
        pills: { primary: 'Soy Alegra Nómina' },
      }),
    },
  },
  SMALL_BUSINESS: {
    default: {
      ...registerBlock({
        hero: pymeDefaultHero,
        features: pymeDefaultFeatures,
      }),
    },
    POS: {
      ...registerBlock({
        hero: posHero,
        features: posFeatures,
      }),
    },
    SF: {
      ...registerBlock({
        hero: {
          title: 'Facture más en menos tiempo con <span class="text-sm-primary-600">ayuda inteligente</span>.',
          subtitle:
            'Emita su primera factura electrónica en minutos y cumpla con Hacienda sin complicaciones.',
        },
        features: {
          1: 'Facturación electrónica 4.4 homologada con Hacienda, sin rechazos.',
          2: 'Cree su catálogo de productos y servicios una vez y reutilícelos en cada factura.',
          3: 'Registre sus clientes y envíe facturas directamente desde la plataforma.',
        },
      }),
    },
  },
  ACCOUNTANT: {
    default: {
      ...registerBlock({
        hero: {
          title: 'Gestione todos sus clientes desde <span class="text-sm-primary-600">un solo lugar</span>.',
          subtitle: 'Administre toda su cartera de clientes desde un panel unificado.',
        },
        features: {
          1: 'Reportes con IA - Obtenga análisis financieros inteligentes en segundos.',
          2: 'Estados financieros, libro diario y reportes tributarios siempre actualizados.',
          3: 'Acceda a la información de sus clientes desde cualquier lugar y dispositivo - 100% en la nube.',
        },
      }),
    },
  },
  MID_BUSINESS: {
    default: {
      ...registerBlock({
        hero: pymeDefaultHero,
        features: pymeDefaultFeatures,
      }),
    },
    POS: {
      ...registerBlock({
        hero: posHero,
        features: posFeatures,
      }),
    },
    AC: {
      ...registerBlock({
        hero: {
          title: 'Controle su negocio y sus finanzas <span class="text-sm-primary-600">desde un solo lugar</span>.',
          subtitle:
            'Facture, registre sus gastos y tenga sus cuentas al día con Hacienda, todo desde una sola plataforma.',
        },
        features: {
          1: 'Facturación electrónica 4.4 homologada con Hacienda, sin rechazos.',
          2: 'Cree su catálogo de productos y servicios una vez y reutilícelos en cada factura.',
          3: 'Reportes financieros en tiempo real para tomar mejores decisiones.',
        },
      }),
    },
    NOMINA: {
      ...registerBlock({
        hero: {
          title: 'Gestiona la nómina de tu <br />equipo desde <span class="text-sm-primary-600">un solo lugar</span>.',
          subtitle: 'Calcula sueldos, deducciones legales y pagos en minutos.',
        },
        features: {
          1: 'Sueldos, deducciones y horas extra se calculan solos, con la DGII siempre al día.',
          2: 'Tus reportes para la DGII se generan automáticamente, listos para enviar.',
          3: 'Tu nómina se integra con tu contabilidad, así todo tu negocio queda conectado.',
        },
        pills: { primary: 'Soy Alegra Nómina' },
      }),
    },
  },
  STUDENT: {
    default: {
      ...registerBlock({
        hero: {
          title: 'Lleve la teoría a la práctica en <span class="text-sm-primary-600">un solo lugar</span>',
          subtitle: 'Explore la plataforma y practique cómo administrar un negocio.',
        },
        features: {
          1: 'Casos prácticos: registre ventas, compras y analice los estados financieros a su ritmo.',
          2: 'Reportes fiscales — vea cómo el sistema calcula los impuestos y genera los reportes.',
          3: 'Practique creando facturas con todos los requisitos.',
        },
      }),
    },
  },
}
